import { BlockchainExplorerLink } from "~/components/BlockchainExplorerLink";
import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { TokenHoldersColumns } from "~/modules/token_holders/types";
import { TokenHolderRowData } from "./types";
import { ImageLoader } from "~/components/ImageLoader";
import { cn } from "~/lib/utils";
import { RWA_COIN_ICON } from "~/consts";
import { DataGridDollarValue } from "~/components/DataGrid/DataGridDollarValue";

// // // //

const RANK_COLUMN: ColumnMetadata<TokenHolderRowData, TokenHoldersColumns> = {
    slug: "rowIndex",
    label: "Rank",
    type: ColumnTypes.number,
    width: 75,
    maxWidth: 75,
    render: (a) => {
        return a.rank;
    },
};

const ADDRESS_COLUMN: ColumnMetadata<TokenHolderRowData, TokenHoldersColumns> =
    {
        slug: TokenHoldersColumns.address,
        label: "Address",
        type: "string",
        width: 200,
        maxWidth: 200,
        render: (item, { size }) => {
            const token = item.token;
            const network = token.network;

            if (!item.holder.address || !network) {
                return <Emdash />;
            }

            return (
                <div className="flex items-center gap-2">
                    <ImageLoader
                        src={network.icon_url as string}
                        className={cn(
                            "rounded-full relative inline-block h-4 w-4 min-w-4",
                        )}
                        alt={`${network.name} Logo`}
                        fallbackSrc={RWA_COIN_ICON}
                        fallbackClassName="bg-white"
                    />
                    <BlockchainExplorerLink
                        address={item.holder.address}
                        networkSlug={network.slug}
                        analyticsLabel="Data Grid - Contract Address Link"
                        size={size}
                        type="address"
                    />
                </div>
            );
        },
    };

// const NETWORK_COLUMN: ColumnMetadata<TokenHolderRowData, TokenHoldersColumns> =
//     {
//         slug: "Network",
//         label: "Network",
//         type: "string",
//         width: 130,
//         visible: true,
//         render: (item) => {
//             const network = item.token.network;

//             if (!network) {
//                 return <Emdash />;
//             }

//             return (
//                 <div className="flex items-center">
//                     <ImageLoader
//                         src={network.icon_url as string}
//                         className={cn(
//                             "rounded-full relative inline-block h-4 w-4 min-w-4",
//                         )}
//                         alt={`${network.name} Logo`}
//                         fallbackSrc={RWA_COIN_ICON}
//                         fallbackClassName="bg-white"
//                     />
//                     <p className="ml-2">{network.name}</p>
//                 </div>
//             );
//         },
//     };

const QUANTITY_COLUMN: ColumnMetadata<TokenHolderRowData, TokenHoldersColumns> =
    {
        slug: TokenHoldersColumns.holdingTokenValue,
        label: "Quantity",
        tooltip: "The quantity of tokens held by each address.",
        type: ColumnTypes.number,
        width: 150,
        render: (item) => {
            const value = item.holder.holding_token_value;
            return Math.round(value).toLocaleString();
        },
    };

// const HOLDING_PERCENT_VALUE_COLUMN: ColumnMetadata<
//     TokenHolderRowData,
//     TokenHoldersColumns
// > = {
//     slug: "holding_percent",
//     label: "Percentage",
//     tooltip: "The percentage of this token held by each address.",
//     type: ColumnTypes.percent,
//     width: 150,
//     visible: true,
//     render: (item) => {
//         const value = item.holder.holding_token_value;
//         const total = item.token.total_supply_token?.val;

//         if (!total) {
//             return <Emdash />;
//         }

//         return <DataGridPercentValue value={value / total} />;
//     },
// };

const HOLDING_TOKEN_VALUE_DOLLAR_COLUMN: ColumnMetadata<
    TokenHolderRowData,
    TokenHoldersColumns
> = {
    slug: TokenHoldersColumns.holdingTokenValueUSD,
    label: "Value",
    tooltip: "The value of the token holdings in US dollars.",
    type: ColumnTypes.dollar,
    width: 150,
    render: (item) => {
        const value = item.holder.holding_token_value_usd;

        return <DataGridDollarValue value={value} />;
    },
};

export const TOKEN_HOLDER_COLUMNS: ColumnMetadata<
    TokenHolderRowData,
    TokenHoldersColumns
>[] = [
    RANK_COLUMN,
    // NETWORK_COLUMN,
    ADDRESS_COLUMN,
    // HOLDING_PERCENT_VALUE_COLUMN,
    HOLDING_TOKEN_VALUE_DOLLAR_COLUMN,
    QUANTITY_COLUMN,
];
